import json5 from "json5"

export default function objectToString(obj) {
  return json5.stringify(obj, null, "\t")
}

